module.exports = __webpack_public_path__ + "img/logo-white.426bd806.svg";